function nameFromManufacturerEntry(entry: unknown): string {
  if (entry == null) return '';
  if (typeof entry === 'string') return entry.trim();
  if (typeof entry !== 'object') return '';
  const o = entry as Record<string, unknown>;
  const nested =
    o.manufacturer && typeof o.manufacturer === 'object'
      ? (o.manufacturer as Record<string, unknown>)
      : undefined;
  const candidates = [
    o.manufacturerName,
    o.manufacturer_name,
    o.tags_name,
    o.name,
    o.label,
    nested?.manufacturerName,
    nested?.manufacturer_name,
  ];
  for (const value of candidates) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }
  return '';
}

function namesFromManufacturerList(list: unknown): string {
  if (!Array.isArray(list)) return '';
  return list
    .map(nameFromManufacturerEntry)
    .filter(Boolean)
    .join(', ');
}

/** Display label for pipe material manufacturer (warehouse + project inventory). */
export function getMaterialManufacturerLabel(
  row: Record<string, unknown> | null | undefined
): string {
  if (!row) return '';

  const details = row.details as Record<string, unknown> | undefined;
  const extra = (details?.pipeExtraDetails as Record<string, unknown> | undefined) ?? {};

  const direct = [
    details?.manufacturerLabel,
    extra.manufacturerLabel,
    row.manufacturerLabel,
    row.manufacturer,
    details?.manufacturer,
  ];
  for (const value of direct) {
    if (typeof value === 'string' && value.trim()) return value.trim();
  }

  const fromArrays = [
    namesFromManufacturerList(row.manufacturers),
    namesFromManufacturerList(row.materialManufacturers),
    namesFromManufacturerList(details?.manufacturers),
    namesFromManufacturerList(details?.materialManufacturers),
  ];
  for (const value of fromArrays) {
    if (value) return value;
  }

  return '';
}

export function manufacturerIdsFromMaterial(row: Record<string, unknown>): number[] {
  const details = row.details as Record<string, unknown> | undefined;
  const detailManufacturerIds = details?.manufacturerIds;
  const raw = [
    ...(Array.isArray(row.materialManufacturerId) ? row.materialManufacturerId : []),
    ...(Array.isArray(detailManufacturerIds) ? detailManufacturerIds : []),
  ];
  return Array.from(
    new Set(raw.map((id) => Number(id)).filter((id) => Number.isFinite(id) && id > 0))
  );
}

export function resolveManufacturerLabelFromIds(
  row: Record<string, unknown>,
  nameById: Map<number, string>
): string {
  const names = manufacturerIdsFromMaterial(row)
    .map((id) => nameById.get(id))
    .filter((n): n is string => Boolean(n?.trim()));
  return Array.from(new Set(names)).join(', ');
}
